/**
 * Stable UUID-shaped IDs for all mock fixtures.
 * Layout: 00000000-0000-0000-AAAA-BBBBBBBBBBBB
 *   AAAA = entity family (c001=customer, d001=provider-user, p001=provider entity, etc.)
 *   BBBB = ordinal
 *
 * Keep these stable across reloads so react-query keys don't churn.
 */

import type { DevRole } from '@/lib/devSession'

// Fixed devSession IDs (must match devSession.ts so dashboards "own" their data)
export const DEV_USER_IDS: Record<DevRole, string> = {
  customer: '00000000-0000-0000-0000-00000000c001',
  provider: '00000000-0000-0000-0000-00000000d001',
  admin: '00000000-0000-0000-0000-0000000000ad',
}

/** Provider entity IDs (separate from user IDs). p001 belongs to dev provider user d001. */
export function providerId(n: number): string {
  return `00000000-0000-0000-0001-${n.toString().padStart(12, '0')}`
}

/** Provider user_id (auth user). u001 belongs to provider p001. u-dev = the dev provider session. */
export function providerUserId(n: number): string {
  return `00000000-0000-0000-0002-${n.toString().padStart(12, '0')}`
}

/** Customer user IDs (besides the dev customer). */
export function customerUserId(n: number): string {
  return `00000000-0000-0000-0003-${n.toString().padStart(12, '0')}`
}

export function categoryId(slug: string): string {
  // Deterministic UUID-shaped string derived from slug.
  let h = 0
  for (let i = 0; i < slug.length; i++) h = ((h << 5) - h + slug.charCodeAt(i)) | 0
  const hex = Math.abs(h).toString(16).padStart(8, '0').slice(0, 8)
  return `cccccccc-cccc-cccc-cccc-${hex.repeat(2).slice(0, 12)}`
}

export function requestEntityId(n: number): string {
  return `00000000-0000-0000-0004-${n.toString().padStart(12, '0')}`
}

export function quoteEntityId(n: number): string {
  return `00000000-0000-0000-0005-${n.toString().padStart(12, '0')}`
}

export function bookingEntityId(n: number): string {
  return `00000000-0000-0000-0006-${n.toString().padStart(12, '0')}`
}

export function reviewEntityId(n: number): string {
  return `00000000-0000-0000-0007-${n.toString().padStart(12, '0')}`
}

export function payoutEntityId(n: number): string {
  return `00000000-0000-0000-0008-${n.toString().padStart(12, '0')}`
}

export function messageEntityId(n: number): string {
  return `00000000-0000-0000-0009-${n.toString().padStart(12, '0')}`
}
